import { render } from "./ButtonScrollComponent.vue?vue&type=template&id=687169c8&scoped=true"
import script from "./ButtonScrollComponent.vue?vue&type=script&lang=js"
export * from "./ButtonScrollComponent.vue?vue&type=script&lang=js"

import "./ButtonScrollComponent.vue?vue&type=style&index=0&id=687169c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687169c8"]])

export default __exports__